import { useEffect, useState } from 'react';

import './Photos.css';

export default function Photos(props) {
    function importPhotos(r, country) {
        let images = {};
        r.keys().map((item, index) => {
            images[item.replace('./', '')] = r(item);
            images[item.replace('./', '')].country = country;
        });
        return images;
    }

    const shuffleArray = (array) => {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    };

    const austria = importPhotos(
        require.context('../imgs/austria', false, /\.jpeg|JPEG/),
        'austria'
    );
    const belgium = importPhotos(
        require.context('../imgs/belgium', false, /\.jpeg|JPEG/),
        'belgium'
    );
    const bolivia = importPhotos(
        require.context('../imgs/bolivia', false, /\.jpeg|JPEG/),
        'bolivia'
    );
    const canada = importPhotos(
        require.context('../imgs/canada', false, /\.jpeg|JPEG/),
        'canada'
    );
    const germany = importPhotos(
        require.context('../imgs/germany', false, /\.jpeg|JPEG/),
        'germany'
    );
    const ireland = importPhotos(
        require.context('../imgs/ireland', false, /\.jpeg|JPEG/),
        'ireland'
    );
    const italy = importPhotos(
        require.context('../imgs/italy', false, /\.jpeg|JPEG/),
        'italy'
    );
    const japan = importPhotos(
        require.context('../imgs/japan', false, /\.jpeg|JPEG/),
        'japan'
    );
    const luxembourg = importPhotos(
        require.context('../imgs/luxembourg', false, /\.jpeg|JPEG/),
        'luxembourg'
    );
    const mexico = importPhotos(
        require.context('../imgs/mexico', false, /\.jpeg|JPEG/),
        'mexico'
    );
    const netherlands = importPhotos(
        require.context('../imgs/netherlands', false, /\.jpeg|JPEG/),
        'netherlands'
    );
    const peru = importPhotos(
        require.context('../imgs/peru', false, /\.jpeg|JPEG/),
        'peru'
    );
    const portugal = importPhotos(
        require.context('../imgs/portugal', false, /\.jpeg|JPEG/),
        'portugal'
    );
    const singapore = importPhotos(
        require.context('../imgs/singapore', false, /\.jpeg|JPEG/),
        'singapore'
    );
    const spain = importPhotos(
        require.context('../imgs/spain', false, /\.jpeg|JPEG/),
        'spain'
    );
    const usa = importPhotos(
        require.context('../imgs/usa', false, /\.jpeg|JPEG/),
        'usa'
    );
    const uk = importPhotos(
        require.context('../imgs/uk', false, /\.jpeg|JPEG/),
        'uk'
    );

    const [imagesArr, setImagesArr] = useState([]);

    useEffect(() => {
        let temp = [
            ...Object.values(austria),
            ...Object.values(belgium),
            ...Object.values(bolivia),
            ...Object.values(canada),
            ...Object.values(germany),
            ...Object.values(ireland),
            ...Object.values(italy),
            ...Object.values(japan),
            ...Object.values(luxembourg),
            ...Object.values(mexico),
            ...Object.values(netherlands),
            ...Object.values(peru),
            ...Object.values(portugal),
            ...Object.values(singapore),
            ...Object.values(spain),
            ...Object.values(usa),
            ...Object.values(uk),
        ];
        setImagesArr(temp);
        shuffleArray(temp);
        console.log(temp.length)
    }, []);

    return (
        <div className="container">
            {imagesArr.map((e, i) => (
                <div className="item" key={e.default}>
                    <img src={e.default} alt={e.country} />
                    {/* <span class="text-content"><span>Place Name</span></span> */}
                </div>
            ))}
        </div>
    );
}
